import { z } from "zod";
import { APP_BANNER_REVIEW_STATUSES } from "./gymAppBanners";

export const APP_BANNER_REJECT_REASON_MAX = 200;

/** Filtro de la cola: un estado, o `ALL` para verlos todos juntos. */
export const APP_BANNER_REVIEW_FILTERS = [
  ...APP_BANNER_REVIEW_STATUSES,
  "ALL",
] as const;
export type AppBannerReviewFilter = (typeof APP_BANNER_REVIEW_FILTERS)[number];

export const appBannerReviewItemSchema = z.object({
  bannerPublicId: z.string(),
  gymPublicId: z.string(),
  gymName: z.string(),
  gymLogoKey: z.string().nullable(),
  imageUrl: z.string().nullable(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  active: z.boolean(),
  requestedAt: z.string(),
  review: z.object({
    status: z.enum(APP_BANNER_REVIEW_STATUSES),
    reason: z.string().nullable(),
    reviewedBy: z.string().nullable(),
    reviewedAt: z.string().nullable(),
  }),
});
export type AppBannerReviewItem = z.infer<typeof appBannerReviewItemSchema>;

export const appBannerReviewsResponseSchema = z.object({
  data: z.array(appBannerReviewItemSchema),
  meta: z.object({
    totalCount: z.number(),
    totalPages: z.number(),
    currentPage: z.number(),
    hasNextPage: z.boolean(),
  }),
});
export type AppBannerReviewsResponse = z.infer<
  typeof appBannerReviewsResponseSchema
>;
